// extracted by mini-css-extract-plugin
module.exports = {"list":"BundleContent_list__2vXip","item":"BundleContent_item__1HbOz","itemIcon":"BundleContent_itemIcon__2DbW1","itemName":"BundleContent_itemName__14SfO"};